export default __webpack_public_path__ + "static/media/knowthyself.5c869e54.png";